import { Chip } from "@material-ui/core";
import { memo } from "react";
import { useRankingClienteService } from "../context/RankingClienteContext";

const OriginChip = ({ origin }) => {
  const { handleRemoveOriginChip } = useRankingClienteService();

  return (
    <Chip
      key={origin.id}
      label={origin.desc}
      onDelete={() => {
        handleRemoveOriginChip(origin);
      }}
      color={"secondary"}
    />
  );
};

export default memo(OriginChip);
